<template>
  <BaseForm class="search-form edit-event-form" verb="Continue" v-bind="forward" @submit="save()">
    <EventFormFields v-if="event" v-model="event"></EventFormFields>
    <JobFilters v-if="showFilters" />
  </BaseForm>
</template>

<script>
import EventFormFields from '@/components/forms/EventFormFields';
import JobFilters from '@/components/search/JobFilters';
import objectForm from '@/mixins/objectForm';
import JobEvent from '@/models/JobEvent';

export default {
  name: 'SearchForm',
  inheritAttrs: false,
  components: { EventFormFields, JobFilters },
  mixins: [objectForm((data) => JobEvent.from(data))],
  props: {
    /** @type {import('vue/types/options').PropOptions<boolean | null | undefined>} */
    noFilters: {
      type: Boolean,
      default: false,
    },
    /** @type {import('vue/types/options').PropOptions<string | null | undefined>} */
    verb: {
      type: String,
      default: 'Generate List',
    },
  },
  computed: {
    /**
     * @returns {JobEvent | null}
     */
    event() {
      return this.model;
    },
    /**
     * @returns {boolean}
     */
    showFilters() {
      return !this.noFilters;
    },
  },
};
</script>
